import { Http } from '../../../support';

const initialState = {
  isValid: false,
  busy: false,
  fetching: false,
  data: {},
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.app.emisores.csd = {
      ...state.app.emisores.csd,
      ...data,
    };
  });
};

const update = async (store, data, id, live = false) => {
  store.setState((state) => {
    state.app.emisores.csd.busy = true;
  });

  try {
    const headers = {
      'X-Tenancy': live ? 'fa/live' : undefined,
    };

    const response = await Http.put(`api/emisores/${id}`, data, { headers });

    store.setState((state) => {
      state.app.emisores.csd.busy = false;
      state.app.emisores.csd.result = response;
      state.app.emisores.csd.data = {
        ...state.app.emisores.csd.data,
        ...response.data,
        series: response.data.series || [],
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.emisores.csd.busy = false;
      state.app.emisores.csd.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.emisores.csd = { ...initialState };
  });
};

const EmisorCsdUpdateStore = {
  state: () => initialState,
  actions: {
    setPartialState,
    update,
    reset,
  },
};

export default EmisorCsdUpdateStore;
